import { render, staticRenderFns } from "./callLog.vue?vue&type=template&id=01bca26d&scoped=true"
import script from "./callLog.vue?vue&type=script&lang=js"
export * from "./callLog.vue?vue&type=script&lang=js"
import style0 from "./callLog.vue?vue&type=style&index=0&id=01bca26d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bca26d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bca26d')) {
      api.createRecord('01bca26d', component.options)
    } else {
      api.reload('01bca26d', component.options)
    }
    module.hot.accept("./callLog.vue?vue&type=template&id=01bca26d&scoped=true", function () {
      api.rerender('01bca26d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/page/callLog.vue"
export default component.exports